// const $ = require('../../../../../../../webpack/node_mod.
const mapNode = document.getElementById('speciesmap')

if(mapNode) {
	const filterButtons = document.getElementsByClassName('speciesmap-filter')
	const subFilterButtons = document.getElementsByClassName('speciesmap-sub-filter')
	const filterSelects = document.getElementsByClassName('speciesmap-filter-select')
	const subFilterDivs = document.getElementsByClassName('sub-filter')
	const subSubFilterDivs = document.getElementsByClassName('sub-sub-filter')
	const map = require('./map')
	const state  = require('./state')
	const config = require('./config')
	const store = state.init(config)
	let filters = store.getState().filters
	let activeButton
	let activeSubButton
	let activeSelects

	map.init(mapNode, store)
	fetch(config.dataUrl)
		.then(response => response.json())
		.then(({filters, locations}) => store.dispatch({type:'locationsLoaded', locations: locations, filters: filters}))
		.catch(onError)

	store.subscribe(() => {
		const state = store.getState()
		if(state.filters != filters) {
			filters = state.filters
			addSelectOptions(filters, config, filterSelects)
		}
		if(state.activeButton != activeButton || state.activeSelects !== activeSelects || state.activeSubButton !== activeSubButton) {
			activeButton = state.activeButton
			activeSubButton = state.activeSubButton
			activeSelects = state.activeSelects
			updateFilterView({activeButton, activeSubButton, activeSelects, subFilterDivs, subSubFilterDivs, config, filterButtons, subFilterButtons, filterSelects})
		}

	})

	addButtonLogic (store, filterButtons, subFilterButtons)
	addSelectLogic (store, filterSelects)
}

function updateFilterView({activeButton, activeSubButton, activeSelects, subFilterDivs, subSubFilterDivs, config, filterButtons, subFilterButtons, filterSelects, ...rest}) {

	for (let button of [...filterButtons, ...subFilterButtons]) {
		let filter = button.dataset.filter

		if(activeButton === filter || activeSubButton === filter) {
			button.classList.add('active')
		} else {
			button.classList.remove('active')
		}
	}

	for (let div of [...subFilterDivs, ...subSubFilterDivs]) {
		let filter = div.dataset.filter

		if(activeButton === filter || activeSubButton === filter) {
			div.style.display = 'block';
		} else {
			div.style.display = 'none';
		}
	}

	for (let select of filterSelects) {
		if(!activeSelects.has(select.dataset.filter)){
			select.value = ''
		}
	}
}

function addButtonLogic (store, filterButtons, subFilterButtons) {
	for (let button of filterButtons) {
		button.addEventListener('click', event => {
			store.dispatch({ type: 'button', filter: button.dataset.filter, value: '1'})
		})
	}
	for (let button of subFilterButtons) {
		button.addEventListener('click', event => {
			store.dispatch({ type: 'subButton', filter: button.dataset.filter, value: '1'})
		})
	}
}

function addSelectLogic (store, filterSelects) {
	for (let select of filterSelects) {
		select.addEventListener('change', event => {
			store.dispatch({ type: 'select', filter: select.dataset.filter, value: select.value})
		})
	}
}

function addSelectOptions(filters, config, filterSelects) {
	const lang = config.lang
	for (let select of filterSelects) {
		let filterKey = select.dataset.filter.replace(/-.*$/, '')
		let filter = filters[filterKey]
		if(filter) {
			filter.sort((a,b) => {
				let aLabel = a.label[lang] || a.label.default
				let bLabel = b.label[lang] || b.label.default

				return aLabel > bLabel ? 1 : -1
			})


			filter.map(filterEntry => {
				let option = getOption(filterEntry, lang)
				select.appendChild(option);
			})
		}
	}
}

function getOption(filter, lang) {
 	let option = document.createElement('option');
	option.value = filter.seal || filter.item
	option.innerText = filter.label[lang] || filter.label.default
	return option
}

function onError(error) {
	console.error(error)
}
